export default __webpack_public_path__ + "static/media/Community-Living-Key-Information-Document-April-2023.37bf0751.pdf";